import React, { useEffect } from 'react';
import Script from 'next/script';
/* *********************** *
 *    FacebookSDK    *
 * *********************** */

export const FacebookSDK = () => {
  useEffect(() => {
    (window as any).FB?.XFBML.parse();
  }, []);
  return (
    <>
      <div id="fb-root"></div>
      <Script
        async
        defer
        strategy="lazyOnload"
        crossOrigin="anonymous"
        src="https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v19.0"
        nonce="dhwRkARX"
      />
    </>
  );
};
